import React, { ReactNode } from 'react';
import { Routes, Route } from 'react-router-dom';
import { FHeader } from '../../FHeader';
import FundManagermenu from '../../fundmanager/fundmanagermenu/FundManagerMenu';
import './FundManagerLayout.css'
import FundDashboard from '../../fundmanager/FundDashboard';
import Orgapplications from '../../fundmanager/Orgapplications';
import FundDocuments from '../../fundmanager/FundDocuments';
import FundFeedbacks from '../../fundmanager/FundFeedbacks';
import FundDonations from '../../fundmanager/FundDonations';
import DonorReports from '../../fundmanager/DonorReports';
import FundOrganizationsReports from '../../fundmanager/FundOrganizationsReports';
import FunAddFeedbacks from '../../fundmanager/FunAddFeedbacks';
import FundViewOrg from '../../fundmanager/FundViewOrg'
import FProfile from '../../fundmanager/FProfile';
import FDonorReportsTranscript from '../../fundmanager/FDonorReportsTranscript';
import FOrgReportsTranscript from '../../fundmanager/FOrgReportsTranscript';
import SelectOragfantion  from  '../../fundmanager/SelectOrganization';
import {Footer} from '../../footer';
import { RestPass } from '../../resetpassword/ResetPassword';
import {MobileDonationlist} from '../../mobile/MobileDonationlist';
import MobileDashboard from '../../mobile/MobileOrgDashboard';
import MobdonorDash from '../../mobile/MobdonorDash';
interface FundManagerLayoutProps {

  children?: ReactNode;
  // Define children as a ReactNode
}

  const FundManagerLayout: React.FC<FundManagerLayoutProps> = ({ children }) => {
  return (
    <div className="admin-layout-container">
      <FHeader />
      <div className="row">
        <FundManagermenu />
        <div >
          <Routes>
            <Route path="/fdashboard" element={<FundDashboard />} />
            <Route path="/orgapplications" element={<Orgapplications />} />
            <Route path="/document" element={<FundDocuments />} />
            <Route path="/ffeedback" element={<FundFeedbacks />} />
            <Route path="/fundslist" element={<FundDonations />} />
            <Route path="/donorreports" element={<DonorReports />} />
            <Route path="/fprofile" element={<FProfile />} />
            <Route path="/forgreports" element={<FundOrganizationsReports />} />
            <Route path="/faddfeedback" element={<FunAddFeedbacks />} />
            <Route path="/orgaproveapp/:application_id" element={<FundViewOrg />} />
          <Route path="/fprinttranscript/:donorid/:rid" element={<FDonorReportsTranscript />} />
          <Route path="/forgprinttranscript/:fundid/:rid" element={<FOrgReportsTranscript />} />
          <Route path="/selectorg/:donationID" element={< SelectOragfantion/>} />
          <Route path="/freset" element={<RestPass />} />
          <Route path="/mobdonationlist/:uid/:usertype" element={<MobileDonationlist/>} />
          
          </Routes>
        </div>
      </div>
      { children }
      <Footer />
    </div>
  );
};

export default FundManagerLayout;
